import { LitElement } from 'lit'
import { property } from 'lit/decorators.js'

import { DescriptionPlacement, LabelPlacement } from '@/common/types'

type Constructor<T = Record<string, unknown>> = {
  new (...args: any[]): T
  prototype: T
}

export interface LabelPositionedElementInterface {
  labelPlacement: LabelPlacement
  descriptionPlacement: DescriptionPlacement
}

export function LabelPositionedMixin<T extends Constructor<LitElement>>(
  constructor: T,
): T & Constructor<LabelPositionedElementInterface> {
  class LabelPositionedElement extends constructor {
    @property() labelPlacement: LabelPlacement = 'right'
    @property()
    descriptionPlacement: DescriptionPlacement = 'bottom'
  }
  return LabelPositionedElement as Constructor<LabelPositionedElementInterface> &
    T
}
